export const initGoToUrl = () => {
  const goToUrls: NodeListOf<HTMLLabelElement> = document.querySelectorAll(".go-to-url");

  if (!goToUrls) {
    return;
  }

  goToUrls.forEach((goToUrl) => {
    goToUrl.addEventListener("click", () => {
      const url = goToUrl.dataset.url;

      if (!url) {
        return;
      }

      if (goToUrl.classList.contains("go-to-blank")) {
        window.open(url, "_blank");
        return;
      }
      window.location.href = url;
    });
  });
};
